import { tooltipClasses } from "@mui/material";
import { JSXElementConstructor, ReactNode, createElement } from "react";
import { TbInfoCircle } from "react-icons/tb";

import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";

export type StatusFilterItemProps<T> = {
    count: number | string | null;
    active: boolean;
    handleUpdate: (val: T, active?: boolean) => void;
    value: T;
    bg: string;
    text: string;
    component: () => JSXElementConstructor<{
        className?: string;
        fontSize?: number;
        color?: string;
    }>;
    tooltip: {
        title: string;
        description: string;
    };
    children?: ReactNode;
};
function StatusFilterItem<T>(status: StatusFilterItemProps<T>) {
    const { component, text, count, active, handleUpdate, children, value } = status;

    const handleClick = () => {
        handleUpdate(value, active);
    };
    return (
        <>
            <button
                onClick={handleClick}
                style={{ color: active ? "white" : text }}
                className=" cursor-pointer min-w-[67px] justify-center  bg-transparent flex gap-1 items-center z-10   hover:scale-105 active:scale-95 duration-200     px-2 py-1 rounded "
            >
                {createElement(component(), {
                    className: "translate-y-[1px]",
                })}
                {count}
                {children}
                <NoMaxWidthTooltip
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 12,
                            maxWidth: "200px !important",
                        },
                    }}
                    arrow
                    title={<HotelStatusTooltip status={status} />}
                >
                    <span className="  !self-start  !translate-x-1 ">
                        <TbInfoCircle size={12} />
                    </span>
                </NoMaxWidthTooltip>
            </button>
        </>
    );
}

export default StatusFilterItem;
